<template>
  <Transition name="modal-fade">
    <slot v-if="isVisible"></slot>
  </Transition>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{ isVisible: boolean }>(), {});
</script>

<style scoped>
/* Styling the modal layout */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
}

/* --- Vue Fade Transition Classes --- */

/* Active state for enter and leave transitions */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

/* Starting state for enter / Ending state for leave */
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
